import MatchAccaSelectionItem from './_match-acca-selection-item.js'
import RemoveSelection from './_remove-selection.js'
import Odds from './_odds.js'
import BetErrors from './_bet-errors.js'
import StakeInput from './_stake-input.js'
import BetslipBet from './_betslip-bet.js'
import FlexPane from './_flex-pane.js'

export default {
  name: 'MatchAccaBetContent',
  values: {
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {},
    },
    removeSelection: {
      configSet: RemoveSelection,
      configValues: {},
    },
    odds: {
      configSet: Odds,
      configValues: {
        updatedPrice: {
          style: {
            flexGrow: 0,
          },
        },
      },
    },
    betErrors: {
      configSet: BetErrors,
      configValues: {},
    },
    stakeInput: {
      configSet: StakeInput,
      configValues: {
        container: {
          style: {
            alignItems: 'flex-end',
          },
        },
      },
    },
    betslipBet: {
      configSet: BetslipBet,
      configValues: {},
    },
    betBuilderInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 0 8px',
        },
      },
    },
    matchAccaInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 0 24px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
